import React from "react";

const PrivacyPolicy = () => {
  return (
    <div>
      <h1>Privacy Policy</h1>
      <p><strong>Last updated:</strong> March 27, 2025</p>

      <p>This privacy policy describes our policies and procedures regarding the collection, use and disclosure of your information when you use the service and tells you about your privacy rights and how the law protects you.</p>
      <p>We use your personal data to provide and improve the service. By using the service, you agree to the collection and use of information in accordance with this privacy policy.</p>

      <h2>Interpretation and Definitions</h2>
      <p><strong>Interpretation:</strong> Capitalized words have specific meanings defined below and apply equally in singular and plural.</p>

      <p><strong>Definitions:</strong></p>
      <p><strong>Account</strong> means a unique account created for you to access our service.</p>
      <p><strong>Affiliate</strong> means an entity under common control with a party.</p>
      <p><strong>Company</strong> refers to Stay Greedless.</p>
      <p><strong>Cookies</strong> are small files placed on your device for tracking and storing preferences.</p>
      <p><strong>Country</strong> refers to Washington, DC United States.</p>
      <p><strong>Device</strong> means any device that can access the service.</p>
      <p><strong>Personal Data</strong> is information that identifies an individual.</p>
      <p><strong>Service</strong> refers to the Website.</p>
      <p><strong>Service Provider</strong> refers to third parties processing data on behalf of the Company.</p>
      <p><strong>Usage Data</strong> refers to data collected automatically through the service.</p>
      <p><strong>Website</strong> refers to Stay Greedless at https://StayGreedless.com/</p>
      <p><strong>You</strong> means the individual or entity using the service.</p>

      <h2>Collecting and Using Your Personal Data</h2>
      <p><strong>Types of Data Collected:</strong></p>
      <p><strong>Personal Data</strong> includes Email, Name, Phone Number, Address, etc.</p>
      <p><strong>Usage Data</strong> includes IP address, browser type, visited pages, etc., including data from mobile devices.</p>

      <h2>Tracking Technologies and Cookies</h2>
      <p>We use cookies and similar technologies such as web beacons and scripts to improve service.</p>
      <p>Types of cookies:</p>
      <p><strong>Necessary Cookies</strong>: Essential for service operation (Session).</p>
      <p><strong>Acceptance Cookies</strong>: Persistent cookies to track consent.</p>
      <p><strong>Functionality Cookies</strong>: Remember preferences like login or language.</p>

      <h2>Use of Your Personal Data</h2>
      <p>Uses include:</p>
      <p>- To provide and maintain our service</p>
      <p>- To manage your account</p>
      <p>- To fulfill contracts and transactions</p>
      <p>- To contact you about important updates</p>
      <p>- To send offers unless opted out</p>
      <p>- For customer support</p>
      <p>- For business transfers or analysis</p>

      <h2>Sharing Your Personal Data</h2>
      <p>We may share your data with:</p>
      <p>- Service Providers</p>
      <p>- Affiliates</p>
      <p>- Business Partners</p>
      <p>- Other users (in public areas)</p>
      <p>- As part of business transfers</p>
      <p>- With your consent</p>

      <h2>Retention of Your Personal Data</h2>
      <p>We retain personal data as long as necessary for legal and service purposes. Usage data may be kept longer for analysis and security.</p>

      <h2>Transfer of Your Personal Data</h2>
      <p>Your data may be transferred to other regions. We ensure data is treated securely with adequate protection measures.</p>

      <h2>Delete Your Personal Data</h2>
      <p>You may delete or request deletion of your data. This can be done via your account settings or by contacting us. Some data may be retained for legal reasons.</p>

      <h2>Disclosure of Your Personal Data</h2>
      <p><strong>Business Transactions:</strong> Data may be transferred if the company is sold or merged.</p>
      <p><strong>Law Enforcement:</strong> We may disclose data as required by law or government requests.</p>
      <p><strong>Other Legal Requirements:</strong> Disclosure may be necessary to:</p>
      <p>- Comply with legal obligations</p>
      <p>- Protect company rights</p>
      <p>- Investigate misconduct</p>
      <p>- Protect user safety</p>
      <p>- Defend against liability</p>

      <h2>Security of Your Personal Data</h2>
      <p>We strive to protect your data but no method is 100% secure. We use commercially acceptable means to safeguard data.</p>

      <h2>Children's Privacy</h2>
      <p>Our service does not target anyone under 18. If we learn of data collected from minors, we will delete it.</p>

      <h2>Changes to this Privacy Policy</h2>
      <p>We may update this policy and will notify users via email or a notice on our site. Continued use means acceptance of changes.</p>

      <h2>Contact Us</h2>
      <p>If you have any questions about this privacy policy, contact us at <strong>hello@StayGreedless.com</strong></p>
    </div>
  );
};

export default PrivacyPolicy;
